export default __webpack_public_path__ + "static/media/imotoPlaceholder.5512d2ec.jpg";